$(document).ready(function () {
    let isDropdownActive = false;


    $(document).on('click', function (event) {
        let container = $('.action__select-variant.active')[0];

        if (isDropdownActive && container && !container.contains(event.target)) {
            $('.action__select-variant.active').removeClass('active');
            isDropdownActive = false;
            if (event.target.matches('.delivery--toggle')) {
                $('.delivery--toggle').trigger("click");
            }
            return false;
        }
    });

    $(document).on('click', '.select-button', function () {
        const $variantSelector = $(this).closest('.action__select-variant');
        if (!isDropdownActive || $variantSelector.hasClass('active')) {
            if ($variantSelector.hasClass('active')) {
                isDropdownActive = false;
                $variantSelector.removeClass('active');
            } else {
                isDropdownActive = true;
                $variantSelector.addClass('active');
                validateInScreenDropdown();
            }
            $(this).attr("aria-expanded", $('.select-button').attr("aria-expanded") === "true" ? "false" : "true");
        }
    });

    //masquer le magasin choisi
    $(document).on('click', '.dropdown--list-stores', function () {
        const $variantSelector = $(this).find('.select-dropdown li');
        $variantSelector.show();
        let $selectedVal = $('.select-store.select-variant').val();
        $('li[value="' + $selectedVal?.toString() + '"]').hide();
    });

    $(document).on('click', '.choice-container', function () {
        isDropdownActive = false;
        let $dropdownVariant = $(this).closest('.action__select-variant');

        $dropdownVariant.removeClass('active');
    });

    $(document).on('click', '.choice-container-store', function () {
        isDropdownActive = false;
        let $dropdownVariant = $(this).closest('.action__select-variant');
        let $value = $(this).parent().attr("value");
        let $name = $(this).parent().attr("name");

        $dropdownVariant.find("select.select-variant").val($value).change();
        $dropdownVariant.find('.selected-value').text($name);
        $dropdownVariant.removeClass('active');
    });

    function validateInScreenDropdown() {
        let el = document.querySelector('.action__select-variant.active .select-dropdown');
        if (el) {
            let rect = el.getBoundingClientRect();
            let overflow = rect.right - window.innerWidth;

            if (overflow > 0) {
                el.style.transform = `translateX(-${overflow + 20}px)`;
            }
        }
    }
});
